import navbar from './navbar.json';
import user from './user.json';
import form from './form.json';
import actions from './actions.json';
import confirmations from './confirmations.json';
import limits from './limits.json';
import pages from './pages.json';
import templates from './templates.json';
import upload from './upload.json';
import companies from './companies.json';
import documents from './documents.json';
import profile from './profile.json';
import auth from './auth.json';
import common from './common.json';
import home from './home.json';
import subscription from './subscription.json';
import ai from './ai.json';
import tour from './tour.json';

export default {
  navbar,
  user,
  form,
  actions,
  confirmations,
  limits,
  pages,
  templates,
  upload,
  companies,
  documents,
  profile,
  auth,
  common,
  home,
  subscription,
  ai,
  tour
};
